import type {AysCodeCodingSystem} from "./code-type.model";

export const AYS_ICD_CODING_SYSTEM_SPECIFICATION = ['icdCode', 'mainDiagnosis', 'secondaryDiagnosis', 'skCode'] as const;
export const AYS_OPS_CODING_SYSTEM_SPECIFICATION = ['opsCode', 'mainProcedure'] as const;
export const ICD_10_AT_CODING_SYSTEM_SPECIFICATION = ['mainDiagnosis', 'secondaryDiagnosis'] as const;
export const ICD_10_UK_CODING_SYSTEM_SPECIFICATION = ['mainDiagnosis', 'secondaryDiagnosis'] as const;
export const OPCS_4_CODING_SYSTEM_SPECIFICATION = ['opcs', 'mainProcedure'] as const;
export const PROCEDURE_AT_CODING_SYSTEM_SPECIFICATION = ['procedure'] as const;

export type AysCodingSystemSpecification =
  AysIcdCodeTypeSpecification
  | AysOpsCodeTypeSpecification
  | Icd10AtCodingSystemSpecification
  | ProcedureAtCodingSystemSpecification
  | Icd10UkCodingSystemSpecification
  | Opcs4CodeTypeSpecification;
export type AysIcdCodeTypeSpecification = typeof AYS_ICD_CODING_SYSTEM_SPECIFICATION[number];
export type AysOpsCodeTypeSpecification = typeof AYS_OPS_CODING_SYSTEM_SPECIFICATION[number];
export type Icd10AtCodingSystemSpecification = typeof ICD_10_AT_CODING_SYSTEM_SPECIFICATION[number];
export type Icd10UkCodingSystemSpecification = typeof ICD_10_UK_CODING_SYSTEM_SPECIFICATION[number];
export type Opcs4CodeTypeSpecification = typeof OPCS_4_CODING_SYSTEM_SPECIFICATION[number];
export type ProcedureAtCodingSystemSpecification = typeof PROCEDURE_AT_CODING_SYSTEM_SPECIFICATION[number];

export const AYS_CODING_SYSTEM_SPECIFICATION_DISPLAY_NAMES: {
  [codingSystemSpecification in AysCodingSystemSpecification]: string
} = {
  icdCode: 'ICD-Ziffer',
  secondaryDiagnosis: 'Nebendiagnose',
  mainDiagnosis: 'Hauptdiagnose',
  mainProcedure: 'Hauptprozedur',
  skCode: 'Sekundär-Ziffer',
  opsCode: 'OPS-Ziffer',
  procedure: 'Prozedur',
  opcs: 'OPCS'
};

export const AYS_CODING_SYSTEM_SPECIFICATION: { [codeType in AysCodeCodingSystem]: AysCodingSystemSpecification[] } = {
  'ICD-10-GM': AYS_ICD_CODING_SYSTEM_SPECIFICATION.map(it => it),
  'ICD-10-AT': ICD_10_AT_CODING_SYSTEM_SPECIFICATION.map(it => it),
  'ICD-10-UK': ICD_10_UK_CODING_SYSTEM_SPECIFICATION.map(it => it),
  'OPS': AYS_OPS_CODING_SYSTEM_SPECIFICATION.map(it => it),
  'OPCS-4': OPCS_4_CODING_SYSTEM_SPECIFICATION.map(it => it),
  'PROCEDURE-AT': PROCEDURE_AT_CODING_SYSTEM_SPECIFICATION.map(it => it),
  'G-DRG': [],
  'ICD-10-CH': [],
  'CHOP': [],
  'SWISS-DRG': []
}
